import React from 'react';
import { motion } from 'framer-motion';

const Team = () => {
  const teamMembers = [
    {
      name: "Arati and Pradeep",
      role: "Founders",
      description: "Co-founders of CDO Nepal, based in Kathmandu, leading grassroots development work in rural communities."
    },
    {
      name: "Cindy Mumm",
      role: "Board Member",
      description: "Dedicated board member providing strategic guidance and oversight. Has volunteered in Nepal and actively supports the US donation platform."
    },
    {
      name: "Private Donors",
      role: "Supporters",
      description: "Generous individuals who believe in our mission and provide ongoing support for our programs."
    },
    {
      name: "Mary Garcia",
      role: "Board Member",
      description: "Dedicated board member providing strategic guidance and oversight for our initiatives."
    },
    {
      name: "Katie Noble",
      role: "Board Member",
      description: "Dedicated board member providing strategic guidance and oversight. Has volunteered in Nepal and actively supports the US donation platform."
    }
  ];

  return (
    <section id="team" className="relative py-24 bg-gradient-to-br from-neutral-900 via-black to-neutral-900">
      {/* Background elements */}
      <div className="absolute inset-0 bg-grid-black opacity-20"></div>
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-gradient-to-r from-amber-500/10 to-yellow-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-gradient-to-r from-yellow-500/10 to-amber-500/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            <span className="text-gradient">
              Our Team
            </span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-600 mx-auto rounded-full mb-8"></div>
          <p className="text-xl text-neutral-300 max-w-3xl mx-auto">
            Meet the dedicated individuals working tirelessly to create positive change in Nepal
          </p>
        </motion.div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="relative group"
            >
              {/* Card */}
              <div className="relative overflow-hidden rounded-2xl bg-neutral-900 border border-neutral-800 group-hover:border-neutral-600 transition-all duration-500 h-full">
                {/* Content */}
                <div className="p-6">
                  {/* Role badge */}
                  <div className="mb-4">
                    <div className="inline-block glass rounded-full px-3 py-1 text-sm font-semibold text-amber-400">
                      {member.role}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors duration-300">
                    {member.name}
                  </h3>
                  <p className="text-neutral-300 leading-relaxed text-sm">
                    {member.description}
                  </p>
                </div>

                {/* Glow effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-amber-500/20 to-yellow-500/20 opacity-0 group-hover:opacity-10 blur-xl transition-opacity duration-500 -z-10"></div>
              </div>

              {/* Floating elements */}
              <div className="absolute -top-2 -right-2 w-16 h-16 bg-gradient-to-r from-amber-500/20 to-yellow-500/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </motion.div>
          ))}
        </div>

        {/* Mission Statement */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
          className="text-center mt-20"
        >
          <div className="glass rounded-2xl p-8 md:p-12 max-w-4xl mx-auto">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
              United by Purpose
            </h3>
            <p className="text-lg text-neutral-300 leading-relaxed">
              Our team combines local expertise with international support to create sustainable change. 
              Together, we're committed to empowering communities and building a brighter future for Nepal's most vulnerable populations.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Team; 